<template>
  <v-menu offset-y max-width="210px">
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" class="menu-activator" v-on="on">
        <span class="menu-activator-label">{{ itemName }}</span>
        <mf-icon icon="expand_more" size="20" color="cinza-d20" />
      </div>
    </template>
    <v-list>
      <v-list-item v-for="(item, index) in items" :key="index" @click="localSelection = item.value">
        <div class="offer-type-option-container">
          <div class="offer-type-option-text-section">
            <span>{{ item.text }}</span>
          </div>
          <div v-if="invalidOfferTypes.includes(item.value)">
            <mf-icon icon="warning" size="20" color="vermelho-0" fill />
          </div>
          <div v-else>
            <mf-icon icon="check_circle" size="20" color="verde-l20" fill />
          </div>
        </div>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OfferTypeOptionsMenu',
  props: {
    selectedOfferType: {
      type: String,
      default: '',
    },
    invalidOfferTypes: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters(['campaign']),
    localSelection: {
      get() {
        return this.selectedOfferType
      },
      set(value) {
        this.$emit('update:selectedOfferType', value)
      },
    },
    itemName() {
      return this.items.find((item) => item.value === this.selectedOfferType)?.text
    },
    iconColor() {
      return '#962EE7'
    },
  },
}
</script>

<style lang="scss" scoped>
.menu-activator {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  .menu-activator-label {
    font-weight: 600;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: 0.1px;
    color: $cinza-d20;
  }
}

.offer-type-option-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 23px;
  padding: 0 8px;
  cursor: pointer;

  .offer-type-option-text-section {
    display: flex;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0%;
    color: #4b525a;
  }
}

::v-deep .v-list-item {
  padding: 0 8px;
}
</style>
